__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "connect-console-accounts";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "11.2.14", function() { return function() { return __webpack_require__(37467); }; }, 1);
			register("@angular/common", "11.2.14", function() { return function() { return __webpack_require__(24374); }; }, 1);
			register("@angular/core", "11.2.14", function() { return function() { return __webpack_require__(8114); }; }, 1);
			register("@angular/router", "11.2.14", function() { return function() { return __webpack_require__(67142); }; }, 1);
			register("@mitel/cloudlink-sdk", "0.1.0-alpha.130", function() { return Promise.all([__webpack_require__.e(3413), __webpack_require__.e(3766)]).then(function() { return function() { return __webpack_require__(63413); }; }); });
			register("@ngx-translate/core", "13.0.0", function() { return Promise.all([__webpack_require__.e(8117), __webpack_require__.e(8592), __webpack_require__.e(4730)]).then(function() { return function() { return __webpack_require__(88117); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};